<script lang="ts" context="module">
  export interface PromptFileViewGroup {
    type: string;
    color: string;
    items: string[];
  }
</script>

<script lang="ts">
  import { onMount } from "svelte";
  import Path from "../scripts/Path";
  import type { Theme } from "../scripts/WinTypes";
  import ProcMgr from "../stores/ProcMgr";
  import SettingsMgr from "../stores/SettingsMgr";

  let contElem: HTMLElement;
  //Theme ============================================================
  const _theme = SettingsMgr.getInstance().theme;
  const themeWatcher = (theme: Theme) => {
    const c = theme.colors;
    items.forEach((group) => {
      group.forEach((item) => {
        if (item.elem) {
          if (item.type === "Directory") {
            (item.elem as HTMLElement).style.setProperty("color", c["2"]);
            (item.elem as HTMLElement).style.setProperty("background", c["1"]);
            return;
          }
          if (item.type === "Application") {
            (item.elem as HTMLElement).style.setProperty("color", c["1"]);
            (item.elem as HTMLElement).style.setProperty("background", c["2"]);
            return;
          }
          (item.elem as HTMLElement).style.setProperty(
            "color",
            c["3"] || c["1"]
          );
          (item.elem as HTMLElement).style.setProperty("background", c["2"]);
        }
      });
    });
    return theme.colors;
  };
  $: _colors = themeWatcher($_theme);
  const themeWatcherStyle = (theme: Theme) => {
    theme.colors;
  };

  export let pwd: Path;
  //   export let highlightColor: string;
  export let groups: PromptFileViewGroup[] = [];
  let items = [];
  groups.forEach((group) => {
    items.push(
      group.items.map((item) => {
        let _: HTMLElement;
        return { elem: _, type: group.type };
      })
    );
  });

  onMount(() => {
    console.log("onmount");
    _colors = themeWatcher($_theme);
  });
  const onItemClick = (e) => {
    e.preventDefault();
    const destPath = Path.join(pwd.path, (e.target as HTMLElement).innerText);
    ProcMgr.getInstance().exeFile(destPath);
  };
</script>

<div class="container" bind:this={contElem}>
  {#if groups.length}
    <div class="grid-container">
      {#each groups as group, i}
        {#each group.items as item, j}
          <span class="item-container">
            <span
              class="item"
              bind:this={items[i][j].elem}
              on:click={onItemClick}>{item}</span
            >
          </span>
        {/each}
      {/each}
    </div>
  {:else}
    {pwd.path} : No Files
  {/if}
</div>

<style>
  .container {
    width: 100%;
  }
  .item:hover {
    font-size: 1.2rem;
    cursor: pointer;
    text-decoration: underline;
  }

  .grid-container {
    box-sizing: border-box;
    padding: 20px 10px;
    display: grid;
    width: 100%;
    /* gap: 15px; */
    column-gap: 15px;
    row-gap: 5px;
    grid-auto-flow: row;
    grid-template-columns: repeat(auto-fill, 170px);
    grid-template-rows: repeat(auto-fill, 20px); /* Your number of rows */
  }

  .item {
    font-size: 1.1rem;
    overflow-y: visible;
    word-break: break-all;
    transition: 0.1s;
  }
</style>
